import Button from 'react-bootstrap/Button';
import { Card, Col, Container, Row } from "react-bootstrap";
import ginTonic from '../../assets/cocktails/ginTonic.jpg'
import PeregrinoVariedades from '../../assets/peregrino/PeregrinoVariedades.jpg'
import AtonitoBotella from '../../assets/atonito/BotellaAtonito2.jpg'
import PaisBotella from '../../assets/pais/botellapaisMarcas.jpg'
import YatayVariedades from '../../assets/aba/YatayVariedades.jpg'
import BotellaMaggiore from '../../assets/aba/BotellaMaggiore.jpg'
import LezardBotella from '../../assets/aba/LezardBotella.jpg'
import BotellaArkasha from '../../assets/aba/BotellaArkasha.jpg'
import BotellaYatay from '../../assets/aba/BotellaYatay.jpg'
import '../ProductFamily/ProductFamilyPage.css'
import { useTranslation } from 'react-i18next';

function FamilyProductsPage() { 

    const { i18n, t } = useTranslation();

    return (
        <Container style={{ marginTop: '30px' }}>
            <Row>
                <Col>
                    <h1>{t('OurBrands')}</h1>
                    <h4>{t('ProductCatalog')}</h4>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col md={4}>
                    <Card style={{ width: '100%', textAlign: 'center'}}>
                    <Card.Img variant="top" src={PeregrinoVariedades}/>
                    <Card.Body>
                        <Card.Title>Peregrino</Card.Title>
                        {/* <Button variant="primary">Ver Mas</Button> */}
                    </Card.Body>
                    </Card>

                </Col>
                <Col md={4}>
                <Card style={{ width: '100%', textAlign: 'center'}}>
                    <Card.Img variant="top" src={AtonitoBotella}/>
                    <Card.Body>
                        <Card.Title>Atónito</Card.Title>
                    </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                <Card style={{ width: '100%', textAlign: 'center'}}>
                    <Card.Img variant="top" src={PaisBotella} />
                    <Card.Body>
                        <Card.Title>Pais</Card.Title>
                    </Card.Body>
                    </Card>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col md={3}>
                    <Card style={{ width: '100%', textAlign: 'center'}}>
                    <Card.Img variant="top" src={BotellaYatay} />
                    <Card.Body>
                        <Card.Title>Yatay</Card.Title>
                    </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card style={{ width: '100%', textAlign: 'center'}}>
                    <Card.Img variant="top" src={BotellaMaggiore} />
                    <Card.Body>
                        <Card.Title>Maggiore</Card.Title>
                    </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card style={{ width: '100%', textAlign: 'center'}}>
                    <Card.Img variant="top" src={LezardBotella} />
                    <Card.Body>
                        <Card.Title>Lezard</Card.Title>
                    </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card style={{ width: '100%', textAlign: 'center'}}>
                    <Card.Img variant="top" src={BotellaArkasha} />
                    <Card.Body>
                        <Card.Title>Arkasha</Card.Title>
                    </Card.Body>
                    </Card>
                </Col>
            </Row>
            <hr/>
        </Container>
    );
}

export default FamilyProductsPage;